import type { IconSvgObject } from './types';

const BounceRightIcon: IconSvgObject = [
  ["path", { d: "M15 10C12.8847 13.01 11.5593 18.066 10.9128 20.9991C9.56719 18.2908 7 15 4 17", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["circle", { cx: "18", cy: "5", r: "2", fill: "currentColor", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default BounceRightIcon;
